import type { PlanVo } from "@/api";
import { VidMuseEvent } from "@/common/events";
import { logger } from "@/common/logger";
import classNames from "classnames";
import Link from "next/link";
import React from "react";
import Button from "../../../component/Button";
import RedeemCodeModal from "../../../component/RedeemCodeModal";
import { PlanCard } from "./PlanCard";
import styles from "./PlanListSection.module.css";

export type BillingCycle = "MONTHLY" | "YEARLY";

interface PlanListSectionProps {
  plans: PlanVo[];
  billingCycle: BillingCycle;
  freeCreditAmount?: number;
  currentPlanCode?: string;
  yearlyDiscount?: string;
  getPlanBonus: (plan: PlanVo) => number;
}

export const PlanListSection: React.FC<PlanListSectionProps> = ({
  plans,
  billingCycle,
  freeCreditAmount,
  currentPlanCode,
  yearlyDiscount,
  getPlanBonus,
}) => {
  const [isRedeemModalOpen, setIsRedeemModalOpen] = React.useState(false);

  return (
    <div className="mt-[86px] px-5 lg:px-0 mx-auto">
      <div
        className={classNames(
          "grid grid-cols-1 gap-[18px] mx-auto",
          styles.planWrap,
        )}
      >
        {plans.map((plan, index, allPlans) => (
          <PlanCard
            key={plan.priceId}
            plan={plan}
            billingCycle={billingCycle}
            freeCreditAmount={freeCreditAmount}
            index={index}
            plans={allPlans}
            currentPlanCode={currentPlanCode}
            yearlyDiscount={yearlyDiscount}
            subscriptionBonus={getPlanBonus(plan)}
          />
        ))}
      </div>

      <div className="mt-8 text-center flex items-center gap-2 justify-center text-sm text-[#A7B0FF] font-medium">
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.google.com/spreadsheets/d/1dkYZmTmzKZPq89Lkrl225f9omQ50iuLAoj87khh7W_Y/edit?usp=sharing"
          className="text-[#A7B0FF]!"
        >
          <span>Model Credit Cost in Details</span>
        </Link>
        <span className="text-white/45">|</span>
        <Button
          type="plain"
          onClick={() => {
            logger.event(VidMuseEvent.PricingPageRedeemCodeClick);
            setIsRedeemModalOpen(true);
          }}
        >
          Redeem Code
        </Button>
      </div>

      <RedeemCodeModal
        open={isRedeemModalOpen}
        onClose={() => setIsRedeemModalOpen(false)}
      />
    </div>
  );
};
